/* eslint-disable */
import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import theme from "../../../../Themes/defaultTheme";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import IconList from "./IconList";
// import { flushBreadCrumps } from "../../../Molecules/Common/PageHeaders/TemplatePageTitle/M_BreadCrumbs.helper";
import { useHistory } from "react-router";
//This list is only for displaying items in list. but no click events are there.
//handling links in list items
function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  list: {
    width: "100%",
  },
  fullList: {
    width: "auto",
  },
  level1: {
    backgroundColor: "var(--total_row_background)",
    paddingLeft: theme.spacing(1),
  },
  level2: {
    backgroundColor: "var(--total_row_boldbackground)",
    paddingLeft: theme.spacing(2),
  },
  listItem: {
    borderRadius: "calc(6px * var(--app-radius-scale, 1))",
    margin: "2px 8px",
    width: "auto",
    transition: "all 0.2s ease",
    color: "var(--color-text-primary)",
    "& .MuiListItemIcon-root": {
      color: "var(--color-text-secondary)",
      minWidth: 40,
      transition: "color 0.2s ease",
    },
    "& .MuiListItemText-primary": {
      color: "inherit",
      fontWeight: 600,
      fontSize: "0.875rem",
    },
    "&:hover": {
      backgroundColor: "var(--total_row_background)",
      color: "var(--color-primary-text)",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text)",
      },
    },
    "&.Mui-selected": {
      backgroundColor: "var(--total_row_boldbackground)",
      color: "var(--color-primary-text)",
      "& .MuiListItemIcon-root": {
        color: "var(--color-primary-text)",
      },
    },
  },
}));
const A_List = (props) => {
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  const classes = useStyles();
  const handleClick = (e, item) => {
    if (e && e.preventDefault) e.preventDefault();
    item.isopen = item.isopen ? !item.isopen : true;
    setOpen(!open);
    
    if (item.url) {
      const isExternal = item.url.startsWith("http") && !item.url.includes(window.location.host);
      if (isExternal) {
        window.open(item.url, "_blank");
      } else {
        // Remove origin if absolute internal URL
        const path = item.url.replace(window.location.origin, "");
        history.push(path);
      }
    }

    if (item.items == null || item.items.length == 0) {
      props.handleDrawer();
    }
  };
  const DrawExpandedlist = (props) => {
    const { item } = props;
    if (!item["primaryText"] || item["primaryText"].length < 1) {
      return;
    }
    return (
      <Collapse in={item.isopen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          id={item.key || item.primaryText}
          key={item.key || item.primaryText}
          className={classes["level" + props.level]}
        >
          {item.items && item.items.length > 0
            ? item.items.map((subItems, index) => {
                if (
                  !subItems ||
                  !subItems["primaryText"] ||
                  subItems["primaryText"].length < 1
                ) {
                  return;
                }
                let url = subItems.url ? subItems.url : null;
                return (
                  <React.Fragment key={subItems.key || subItems.primaryText}>
                    <ListItemLink
                      button
                      className={classes.listItem}
                      key={subItems.key || subItems.primaryText}
                      onClick={(e) => handleClick(e, subItems)}
                      href={url}
                    >
                      {/* <ListItemIcon>{subItems.icon}</ListItemIcon> */}
                      <ListItemIcon>
                        <IconList icon={subItems.icon} />
                      </ListItemIcon>
                      <ListItemText primary={subItems.primaryText} />
                      <ExpandIcon listItem={subItems} />
                    </ListItemLink>
                    <ExpandList listItem={subItems} level={2} />
                  </React.Fragment>
                );
              })
            : ""}
        </List>
      </Collapse>
    );
  };
  const ExpandIcon = (props) => {
    const { listItem } = props;
    return listItem && listItem.items && listItem.items.length > 0 ? (
      !listItem.isopen ? (
        <ExpandMore />
      ) : (
        <ExpandLess />
      )
    ) : (
      ""
    );
  };
  const ExpandList = (props) => {
    const { listItem } = props;
    return listItem && listItem.items && listItem.items.length > 0 ? (
      <DrawExpandedlist
        key={listItem.key || listItem.primaryText}
        item={listItem}
        level={props.level}
      />
    ) : (
      ""
    );
  };
  const DrawListItems = (props) => {
    const { listItem } = props;
    let url = listItem.url ? listItem.url : null;
    if (!listItem["primaryText"] || listItem["primaryText"].length < 1) {
      return;
    }
    return (
      <React.Fragment>
        <ListItemLink
          button
          className={classes.listItem}
          id={listItem.key || listItem.primaryText}
          key={listItem.key || listItem.primaryText}
          //onClick={listItem.onClick}
          onClick={(e) => handleClick(e, listItem)}
          component="a"
          href={url}
        >
          {/* <ListItemIcon >{ReactHtmlParser(listItem.icon)}</ListItemIcon> */}
          <ListItemIcon>
            <IconList icon={listItem.icon} />
          </ListItemIcon>
          <ListItemText primary={listItem.primaryText} />
          <ExpandIcon listItem={listItem} />
        </ListItemLink>
        <ExpandList listItem={listItem} level={1} />
      </React.Fragment>
    );
  };

  const ListItems = props.listItems.map((listItem, index) => {
    if (!listItem["primaryText"] || listItem["primaryText"].length < 1) {
      return;
    }
    return (
      <DrawListItems
        key={listItem.key || listItem.primaryText}
        listItem={listItem}
      />
    );
  });
  return (
    <ThemeProvider theme={theme}>
      {/* <React.Fragment>
        <ListItemLink
          button
          id="Main Manu"
          key="Main Manu"
          onClick={props.onClose}
          //onClick={listItem.onClick}
          component="a"
          href={null}
        >
          <KeyboardBackspaceIcon />
          <ListItemText primary=" Main Menu" />
        </ListItemLink>
      </React.Fragment> */}
      <Divider />
      <List
        component="nav"
        aria-label={props.ariaLabel}
        className={classes.list}
      >
        {ListItems}
      </List>
    </ThemeProvider>
  );
};
A_List.defaultProps = {
  listItems: [],
};
export default A_List;
